import {
	mediaQueryBreakpointSM,
	collapseElement,
	expandElement,
	scrollToPosition
} from "../../utils/Utils.js";

const Documents = (domEl) => {

	if(!domEl) {
		return;
	}

	const categoryButtons = domEl.querySelectorAll('.category-btn');
	const categoryContent = domEl.querySelectorAll('.category-content');

	if(!categoryButtons || !categoryContent) {
		return;
	}


	const handleCategoryButtonClicked = (e) => {
		if(e) {
			e.preventDefault();
		}

		// Get the new value for document-category from the button's data-url attribute
		const newCategoryValue = e.currentTarget.dataset.url;

		// Create a new URLSearchParams object from the current page's query string
		const searchParams = new URLSearchParams(window.location.search);

		// Set the new value for the document-category parameter
		searchParams.set('document-category', ( searchParams.get('document-category') === newCategoryValue ? '' : newCategoryValue));

		// Update the current URL with the new query string, without reloading the page
		const newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
		history.replaceState({}, '', newURL);

		render();
	}

	const render = () => {

		// Get the active url
		const searchParams = new URLSearchParams(window.location.search);
		const currentUrl = searchParams.get('document-category');

		// Update the visibility of the category buttons
		categoryButtons.forEach(btn => {
			if(btn.dataset.url === currentUrl) {
				btn.classList.add('js-is-active');
			}
			else {
				btn.classList.remove('js-is-active');
			}
		});

		// Get the height of #the-header
		const headerHeight = document.querySelector("#the-header").offsetHeight;

		// Update the visibility of the category content
		categoryContent.forEach(content => {
			if(content.dataset.url === currentUrl) {
				content.classList.add('js-is-active');
				if(window.innerWidth < mediaQueryBreakpointSM) {
					const extraOffset = 145;
					scrollToPosition(content.getBoundingClientRect().top + window.scrollY - headerHeight - extraOffset, 300);
				}
			} else {
				content.classList.remove('js-is-active');
			}
		});
	}

	// Get all category-heading elements
	const categoryHeadings = domEl.querySelectorAll('.category-heading');

	categoryHeadings.forEach(heading => {
		heading.addEventListener('click', (e) => {
			e.preventDefault();

			// Get the sibling category-files for this heading
			const categoryFiles = e.currentTarget.nextElementSibling;
			const subCategory = categoryFiles.parentNode;

			if(subCategory.classList.contains('js-expanding') || subCategory.classList.contains('js-expanded') ) {
				collapseElement(categoryFiles, () => {
					subCategory.classList.remove('js-expanding');
					subCategory.classList.remove('js-expanded');
					subCategory.classList.add('js-concealed');
					subCategory.setAttribute('aria-expanded', false);
				});
			}
			else {
				subCategory.classList.remove('js-concealed');
				subCategory.classList.add('js-expanding');
				expandElement(categoryFiles, () => {
					subCategory.classList.add('js-expanded');
					subCategory.classList.remove('js-expanding');
					subCategory.setAttribute('aria-expanded', true);
				});
			}
		});
	});


	// Enable navigation
	categoryButtons.forEach(btn => btn.addEventListener('click', handleCategoryButtonClicked));

	// Listen for changes in the url
	window.addEventListener('popstate', (e) => {
		render();
	});
};

export default Documents;